import {combineReducers} from 'redux';
import UserReducer from './UserReducer';
import RolesReducer from './RolesReducer';
import OrganizationsReducer from './OrganizationsReducer';
const combinedReducers = combineReducers({
	user: UserReducer,
	roles: RolesReducer,
	organizations: OrganizationsReducer,
});
export default combinedReducers;